import { render, staticRenderFns } from "./TodayMenuList.vue?vue&type=template&id=00532581&scoped=true"
import script from "./TodayMenuList.vue?vue&type=script&lang=js"
export * from "./TodayMenuList.vue?vue&type=script&lang=js"
import style0 from "./TodayMenuList.vue?vue&type=style&index=0&id=00532581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00532581",
  null
  
)

export default component.exports